import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CloakPageComponent } from './cloak-page/cloak-page.component';
import { CloakPage2Component } from './cloak-page2/cloak-page2.component';
import { CloakPage3Component } from './cloak-page3/cloak-page3.component';

@NgModule({
  declarations: [
    AppComponent,
    CloakPageComponent,
    CloakPage2Component,
    CloakPage3Component
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
